import { render, staticRenderFns } from "./ReportBdCollateral.vue?vue&type=template&id=7ac79d46&scoped=true&"
import script from "./ReportBdCollateral.vue?vue&type=script&lang=js&"
export * from "./ReportBdCollateral.vue?vue&type=script&lang=js&"
import style0 from "./ReportBdCollateral.vue?vue&type=style&index=0&id=7ac79d46&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ac79d46",
  null
  
)

export default component.exports